var _path;
function _extends() { _extends = Object.assign ? Object.assign.bind() : function (target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i]; for (var key in source) { if (Object.prototype.hasOwnProperty.call(source, key)) { target[key] = source[key]; } } } return target; }; return _extends.apply(this, arguments); }
import * as React from "react";
var SvgSearch = function SvgSearch(props) {
  return /*#__PURE__*/React.createElement("svg", _extends({
    xmlns: "http://www.w3.org/2000/svg",
    fill: "currentColor",
    viewBox: "0 0 24 24"
  }, props), _path || (_path = /*#__PURE__*/React.createElement("path", {
    fillRule: "evenodd",
    d: "M11.739 2c5.37 0 9.738 4.368 9.738 9.738a9.703 9.703 0 0 1-2.563 6.579l3.13 3.124a.749.749 0 1 1-1.06 1.062l-3.168-3.16a9.691 9.691 0 0 1-6.077 2.134C6.369 21.477 2 17.108 2 11.738 2 6.368 6.369 2 11.739 2Zm0 1.5C7.196 3.5 3.5 7.195 3.5 11.738c0 4.543 3.696 8.239 8.239 8.239 4.542 0 8.238-3.696 8.238-8.239 0-4.543-3.696-8.238-8.238-8.238Z",
    clipRule: "evenodd"
  })));
};
export default SvgSearch;